import { writable } from "svelte/store"

export const categories = writable([{runs: []}])